import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { EPF } from 'src/model/epf.model';
import { Task } from 'src/model/task.model';
import { EpfService } from 'src/services/epf.service';

@Component({
    selector: 'app-follow-next-task',
    templateUrl: './follow-next-task.component.html',
    styleUrls: ['./follow-next-task.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class NextTaskComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private datepipe = inject(DatePipe);
  private epfService = inject(EpfService);

  @Input() task: Task;
  @Input() isEPF = false;
  newDescription = "";
  newDate: Date;

  epfDetails: EPF;

  ngOnInit(): void {
    if (this.isEPF == true)
      this.getEPFDetails(this.task.CustomerId)
  }

  async getEPFDetails(customerID: number) {
    try {
      this.epfDetails = await this.epfService.getCustomerEPF(customerID);
    } catch (error) {
      this.reset();
    }
  }

  checkNull() {
    let error = "";
    if (this.task.FollowUpRemark == undefined || this.task.FollowUpRemark == '')
      error += "- Customer Says\n";

    if (this.newDescription == '')
      error += "- Customer Promise\n";

    if (this.newDate == undefined)
      error += "- Continue Follow Date";

    const start = "Please key in:\n";
    if (error != "")
      error = start + error;
    return error;
  }

  submit() {
    const error = this.checkNull()
    if (error != "")
      this.sharedService.openAlert(error, ALERT_TYPE.DANGER);
    else {
      this.updateTask();
    }
  }

  updateTask() {
    const doneDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    const newDateStr = this.datepipe.transform(this.newDate, 'yyyy-MM-dd');
    const data = {
      "followUpRemark": this.task.FollowUpRemark,
      "date": doneDate,
      "newDate": newDateStr,
      "newDescription": this.newDescription
    };

    const xhr = this.restApi.putRequest(this.constructApi.getMarkProfileTaskAsDone(this.task.ProfileId, this.task.ID), data);

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        window.location.reload();
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
